export function isImeComposingKeyEvent(event) {
  if (!event) return false;

  const nativeEvent = event.nativeEvent;
  return Boolean(
    event.isComposing ||
      nativeEvent?.isComposing ||
      event.keyCode === 229 ||
      nativeEvent?.keyCode === 229,
  );
}

export function shouldSubmitOnEnter(event) {
  if (!event) return false;
  if (event.key !== "Enter" || event.shiftKey) return false;
  if (isImeComposingKeyEvent(event)) return false;
  return true;
}
